import moment from "moment";
import { ReduxStateAuth } from "../types/redux/reduxStateAuth";

const passwordDaysToExpire = (authRedux: ReduxStateAuth): number => {
    return moment(new Date(authRedux.passwordValidUntil)).diff(moment(), "days");
};

const passwordShowAlert = (authRedux: ReduxStateAuth): boolean => {
    return (authRedux.passwordWarnDays > 0) ?passwordDaysToExpire(authRedux) <= authRedux.passwordWarnDays : false;
};

export { passwordDaysToExpire, passwordShowAlert };
